import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/About1.css";
import { useNavigate } from "react-router-dom";

const rotatingWords = ["CAMPUS", "CORPORATE", "CAREER"];

const About1 = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("C");

  useEffect(() => {
    const word = rotatingWords[index];
    let charIndex = 1; // start after 'C'

    const type = () => {
      if (charIndex <= word.length) {
        setText("C" + word.slice(1, charIndex));
        charIndex++;
        setTimeout(type, 120);
      } else {
        setTimeout(() => {
          setIndex((prev) => (prev + 1) % rotatingWords.length);
        }, 1000);
      }
    };

    type();
  }, [index]);

  const displayedText =
    text.length > 1 ? text : "C" + rotatingWords[index].slice(1);

  return (
    <Container fluid className="about-section ">
      <Row className="align-items-center about-row">
        <Col md={12} className="about-content">
          <h1 className="text-secondary about-heading">
            WOMEN IN SEMICONDUCTOR ECOSYSTEM FOR{" "}
            <span className="wise-secondary-gradient">{displayedText}</span>
          </h1>
          <p className="text-secondary about-description">
            WiSE is a dynamic platform created to empower, connect, and elevate
            women across every stage of their journey — from campus to corporate
            to career. We bring together a vibrant community of professionals,
            students, and leaders in the semiconductor industry to share
            knowledge, foster mentorship, and open doors to new opportunities.
            At WiSE, we believe in building not just careers, but also
            confidence, connections, and a more inclusive future for all Women
            in Semiconductor Ecosystem!
          </p>
          <p
  className="join-link"
  onClick={() => navigate("/contactus")}
>
  {/* Become a Part of WiSE → */}
   Connect With WiSE Today →
</p>
        </Col>
      </Row>
    </Container>
  );
};

export default About1;
